import { MagentoAddress, MagentoCustomAttribute } from '.';

export interface MagentoCustomer {
  id: number;
  group_id: number;
  created_at: string;
  updated_at: string;
  created_in: string;
  email: string;
  firstname: string;
  lastname: string;
  gender: number;
  store_id: number;
  website_id: number;
  addresses: MagentoAddress[];
  disable_auto_group_change: number;
  extension_attributes: {
    is_subscribed: boolean;
  };
  custom_attributes: MagentoCustomAttribute[];
}
